import { MasterDataResponse } from "@/types/api-response";
export const masterDataInitialState: MasterDataResponse = (() => {
    
    return  {
      topCities: [],
      internationalLocations: [],
      regionAndStates: [],
      allFunctions: [],
      topIndustriesList: [],
      otherIndustriesList: [],
      topIndustryClusters: [],
      languages: undefined,
      topEducationClusters: undefined,
      eduStreamData: undefined,
      removeEduStreams: undefined,
      topCollegeClusters: undefined,
      citizenship: [],
      currency: [],
      differentlyAbled: undefined,
      noticePeriod: [],
      usVisa: undefined,
      visaStatus: undefined
    }
})()